<template>
  <div class="el-table-container templateBox">
    <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
             @keyup.enter.native="refreshList(1,1,1)" label-width="100px">
      <el-form-item label="业务描述：" prop="incidentDescription">
        <el-input v-model.trim="searchForm.incidentDescription" maxlength="20"
                  placeholder="请输入业务描述(限20字)"
                  clearable></el-input>
      </el-form-item>
      <el-form-item label="创建时间：" prop="createTime">
        <el-date-picker
            v-model="searchForm.createTime"
            clearable
            style="width: 100%"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="所在系统：" prop="localSystem">
        <el-select v-model="searchForm.localSystem" clearable placeholder="请选择所在系统" style="width: 100%">
          <el-option
              v-for="item in $dictUtils.getDictList('sys_menu_local_system')"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="业务模块：" prop="businessType">
        <el-select v-model="searchForm.businessType" clearable placeholder="请选择业务模块" style="width: 100%">
          <el-option
              v-for="item in createByList"
              :key="item.businessType"
              :label="item.businessType"
              :value="item.businessType">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="refreshList(1,1,1)" size="small" icon="el-icon-search">查询</el-button>
        <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="dataBox">
      <el-tabs v-model="searchForm.eventStatus" type="card" @tab-click="refreshList(1,1,1)">
        <el-tab-pane label="我的待办" name="0"></el-tab-pane>
        <el-tab-pane label="我的已办" name="1"></el-tab-pane>
      </el-tabs>
      <el-table
          :data="dataList"
          v-loading="loading"
          size="small" height="calc(100% - 60px)"
          class="table" border
          ref="multipleTable"
          :row-key="'id'"
      >
        <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="incidentDescription" label="业务描述" show-overflow-tooltip></el-table-column>
        <el-table-column prop="incidentStatus" label="审核状态" show-overflow-tooltip></el-table-column>
        <el-table-column prop="businessType" label="业务模块" show-overflow-tooltip></el-table-column>
        <el-table-column prop="localSystem" label="所在系统" show-overflow-tooltip>
          <template slot-scope="{row}">
            <div>
              {{ $dictUtils.getDictLabel("sys_menu_local_system", row.localSystem, '') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createName" label="执行人" show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" min-width="100px" label="操作">
          <template slot-scope="{row,$index}">
            <el-button v-if="searchForm.eventStatus == 0"
                       type="text" size="small"
                       @click="deteil(row,$index)">详情
            </el-button>
            <el-button v-if="searchForm.eventStatus == 1"
                       type="text" size="small"
                       @click="deteil2(row,$index)">详情
            </el-button>
            <el-button v-if="searchForm.eventStatus == 0"
                       v-show="row.localSystem == '3' || row.localSystem == '3'"
                       type="text" size="small"
                       @click="goHandleIt(row,$index)">去处理
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                @pagination="refreshList"/>
    <resource-add-edit-form ref="resourceAddEditForm" @refreshData="refreshList()"></resource-add-edit-form>
    <add-borrowing ref="addBorrowing" @refresh="refreshList()"></add-borrowing>
    <audit-form ref="auditForm" @refreshData="refreshList()"></audit-form>
    <set-toexamine ref="setToexamine" @refresh="refreshList()"></set-toexamine>
  </div>
</template>

<script>


import AuditForm from "@/components/auditForm/auditForm.vue";
import ResourceAddEditForm from "@/views/modules/dyygCollect/library/resourceAddEditForm.vue";
import AddBorrowing from "@/views/modules/academic/applyFor/addBorrowing.vue";
import SetToexamine from "@/views/modules/workbenches/setToexamine.vue";

export default {
  name: "pending",
  components: {SetToexamine, AddBorrowing, ResourceAddEditForm, AuditForm},
  data() {
    return {
      searchForm: {
        incidentDescription: '',
        createTime: [],
        createStartDate: '',
        createEndDate: '',
        localSystem: '',
        businessType: '',
        eventStatus: '0',
        current: 1,
        size: 20,
      },
      total: 0,
      createByList: [],

      loading: false,
      dataList: [],
    }
  },

  mounted() {
    this.refreshList()
    this.getOtherList()
  },

  methods: {
    // 获取数据列表 current查第几页数据
    refreshList(type, clearSelect) {
      if (type == 1) {
        this.searchForm.current = 1
      }
      if (clearSelect) {
        this.$refs.multipleTable.clearSelection()
      }
      let searchData = JSON.parse(JSON.stringify(this.searchForm))
      if (searchData.createTime && searchData.createTime.length != 0) {
        searchData.createStartDate = searchData.createTime[0]
        searchData.createEndDate = searchData.createTime[1]
      } else {
        searchData.createStartDate = ''
        searchData.createEndDate = ''
      }
      this.$delete(searchData,'createTime')
      this.loading = true
      this.$axios(this.api.allCommon.commonBacklogList, searchData, 'get').then(data => {
        if (data && data.status) {
          this.dataList = data.data.records
          if (this.dataList.length == 0 && this.searchForm.current > 1) {
            this.searchForm.current--
            this.refreshList()
          }
          this.total = parseInt(data.data.total)
          this.loading = false
        } else {
          this.$message.error('查询失败')
        }
      })
    },

    // 重置
    reset() {
      this.$refs.searchForm.resetFields();
      this.refreshList(1, 1, 1)
    },

    getOtherList() {
      this.$axios(this.api.allCommon.selectBusinessTypeAll).then(data => {
        if (data && data.status) {
          this.createByList = data.data
        }
      })
    },

    //去处理
    goHandleIt(row) {
      let ids, url, type
      ids = [row.labelResourceId]
      url = this.api.academic.resourceslabelAudit
      type = '标引'
      if (row.localSystem == '3' && !row.metadataFonctionsModelDetailId) {
        url = this.api.academic.resourceapplicationAudit
        type = '借阅'
      }
      this.$refs.setToexamine.init(ids, type, url)
    },

    //详情
    deteil(row, index) {
      switch (row.localSystem) {
        case 0:
          //多源异构采集子系统
          this.$refs.resourceAddEditForm.init('view', row.businessId, row.metadataTableConfigId, row.basicDataId)
          break;
        case '1':
          //多源异构汇聚子系统
          //标引
          this.$refs.resourceAddEditForm.init('view', row.labelResourceId, '', row.basicDataId, null, {
            labeState: 1,
            id: row.businessId
          }, 'markIndex')
          break;
        case '2':
          //资源监管子系统
          break;
        case '3':
          //学术研究子系统
          //标引
          if (row.metadataFonctionsModelDetailId) {
            this.$refs.resourceAddEditForm.init('view', row.businessId, '', row.basicDataId, null, {
              labeState: 1,
              id: row.businessId
            }, 'markIndex')
          } else {
            //借阅
            let dataRow = JSON.parse(JSON.stringify(row))
            dataRow.id = dataRow.businessId
            this.$refs.addBorrowing.init(dataRow, 'toExamineView')
          }
          break;
        case '4':
          //多源异构发布子系统
          this.$refs.resourceAddEditForm.init('view', row.businessId, row.metadataTableConfigId, row.basicDataId)
          break;
        default:
          this.$refs.resourceAddEditForm.init('view', row.businessId, row.metadataTableConfigId, row.basicDataId)
          //公共系统
      }
    },

    deteil2(row){
      switch (row.localSystem) {
        case 0:
          //多源异构采集子系统
          this.$refs.resourceAddEditForm.init('view', row.businessId, '', row.basicDataId)
          break;
        case '1':
          //多源异构汇聚子系统
          //标引
          this.$refs.resourceAddEditForm.init('view', row.labelResourceId, '', row.basicDataId, null, {
            labeState: 1,
            id: row.businessId
          }, 'markIndex')
          break;
        case '2':
          //资源监管子系统
          break;
        case '3':
          //学术研究子系统
          //标引
          if (row.metadataFonctionsModelDetailId) {
            this.$refs.resourceAddEditForm.init('view', row.businessId, '', row.basicDataId, null, {
              labeState: 1,
              id: row.businessId
            }, 'markIndex')
          } else {
            //借阅
            let dataRow = JSON.parse(JSON.stringify(row))
            dataRow.id = dataRow.businessId
            this.$refs.addBorrowing.init(dataRow, 'toExamineView')
          }
          break;
        case '4':
          //多源异构发布子系统
          this.$refs.resourceAddEditForm.init('view', row.businessId, '', row.basicDataId)
          break;
        default:
          this.$refs.resourceAddEditForm.init('view', row.businessId, '', row.basicDataId)
          //公共系统
      }
    },
  },
}
</script>

<style scoped>

</style>
